<template>
  <v-container class="pb-5 pt-0 px-0">
    <v-col class="d-flex justify-end py-0 px-0" cols="12" sm="12" md="12">
      <v-btn
        color="primary"
        text
        @click="downloadFile()"
        :disabled="list.length == 0"
      >
        <v-icon small class="pr-2">fa-download</v-icon>
        Exportar resultado
      </v-btn>
    </v-col>
      <v-data-table
      dense
      :headers="headers"
      :items="list"
      class="pagamentosListTable"
      :items-per-page="-1"
      hide-default-footer>
        <template v-slot:item.data_inicio_monitoramento="{ item }">
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="pr-2">
                <v-icon :color="colorList['executado']" small>
                  {{iconList['executado'] }}
                </v-icon>
              </span>
            </template>
            <span
              class="px-3 py-1 ma-0"
              style=" border: solid 1px #999; border-radius: 5px; background-color: #fff;"
              >
              {{ labelList['executado'] }}
              </span>
          </v-tooltip> -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="pr-2">
                <v-icon :color="colorList[item.status]" small>
                  {{iconList[item.status] }}
                </v-icon>
              </span>
            </template>
            <span
              class="px-3 py-1 ma-0"
              style=" border: solid 1px #999; border-radius: 5px; background-color: #fff;"
              >
              {{ labelList[item.status] }}
              </span>
          </v-tooltip>
          {{item.data_inicio_monitoramento | formatDate}}
        </template>
        <template v-slot:item.data_evento="{item}">
          {{item.data_evento | formatDate}}
          <v-btn @click="getHistorico(item)" small color="primary" icon>
              <v-icon small>fa-history</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.evento="{item}">
          <!-- <span v-if="!item.erro">{{item.evento}}<br><small>{{item.mensagem}}</small></span> -->
          <span v-if="!item.erro">{{item.mensagem}}</span>
          <span v-else style="color:#D0021B">{{item.mensagem}}</span>
          <v-btn v-if="item.evento_id == '100'" @click="setFilter(item)" class="pb-1" x-small color="primary" icon>
              <v-icon x-small>fas fa-external-link-alt</v-icon>
            </v-btn>
        </template>
      </v-data-table>
      <v-pagination
          class="no-box-shadow"
          v-model="page"
          :length="pagination.total_pages"
          @input="getList(filterData, page)"
        ></v-pagination>

  </v-container>
</template>

<script>
export default {
    data() {
      return {
        colorList:{
          executado: "success", 
          em_execucao: "warning",
          com_intercorrencia: "error"
        },
        headers: [
            { text: "Data do processo", value: "data_inicio_monitoramento", sortable: false },
            { text: "Operadora", value: "oper_nome", sortable: false },
            { text: "Prestador", value: "prest_nome", sortable: false },
            { text: "Ident. na Operadora", value: "identificador_prestador", sortable: false },
            { text: "Data do últ. evento", value: "data_evento", sortable: false },
            { text: "Evento", value: "evento", sortable: false },
        ],
        iconList:{
          executado: "fa-check-circle", 
          em_execucao: "fas fa-exclamation-triangle",
          com_intercorrencia: "fas fa-exclamation-circle"
        },
        labelList:{
          executado: "Executado", 
          em_execucao: "Em execução",
          com_intercorrencia: "Com intercorrência"
        },
        page: 1
      }
    },
    props: {
      filterData: Object,
      getHistorico: Function,
      list: Array,
      pagination: Object,
      getList: Function,
      showOpen: Function,
    },
    methods: {
      downloadFile(){
      let acao = "getcsvprocessosidentificacao"
      let Payload = {...this.filterData}
      this.$store.dispatch("documents/getDocumentPost", { Payload, acao, callback: ()=> setTimeout(()=>{ this.getList(this.filterData, this.pagination.offset) }, 500) }, {root:true})
      },
      setFilter(item){
        let { operadora_ans_id, prestador_id } = item
        let grupo_economico = this.$store.state.permissions.grupoEconomico
        let filter = {
          filterData: {
            grupo_economico,
            login_valido: false,
            operadora_ans_id: [operadora_ans_id] , 
            prestador_id: [prestador_id],
          },
          filterName: 'identNaOperadoraFilter',
          redirect: true
        }
        this.$store.commit('recebiveis/setFilter', filter, { root:true })
      },
      sortSelectValue(item) {
        let sort = item.sortBy[0] ? item.sortBy[0] : null;
        let order =
          item.sortDesc.length > 0 ? (item.sortDesc[0] ? "Desc": "Asc") : null;
        let newFilter = {...this.filterData, sort, order}
        this.getList(newFilter, 1);
      },
    },
}
</script>

<style>
.theme--light.v-data-table.pagamentosListTable > .v-data-table__wrapper > table > thead > tr > th:nth-child(2),
.theme--light.v-data-table.pagamentosListTable > .v-data-table__wrapper > table > tbody > tr > td:nth-child(2) {
  max-width: 200px;
}
.theme--light.v-data-table.pagamentosListTable > .v-data-table__wrapper > table > thead > tr > th:nth-child(3),
.theme--light.v-data-table.pagamentosListTable > .v-data-table__wrapper > table > tbody > tr > td:nth-child(3) {
  max-width: 150px;
}
.theme--light.v-data-table.pagamentosListTable > .v-data-table__wrapper > table > thead > tr > th:nth-child(1),
.theme--light.v-data-table.pagamentosListTable > .v-data-table__wrapper > table > tbody > tr > td:nth-child(1),
.theme--light.v-data-table.pagamentosListTable > .v-data-table__wrapper > table > thead > tr > th:nth-child(5),
.theme--light.v-data-table.pagamentosListTable > .v-data-table__wrapper > table > tbody > tr > td:nth-child(5) {
  min-width: 125px;
}
.theme--light.v-data-table.pagamentosListTable > .v-data-table__wrapper > table > thead > tr > th:nth-child(6),
.theme--light.v-data-table.pagamentosListTable > .v-data-table__wrapper > table > tbody > tr > td:nth-child(6) {
  max-width: 400px;
}
</style>